<template>
    <div class="registration-layout relative flex flex-col lg:flex-row">

        <div class="left-guide p-2 p-8 z-50 w-full lg:w-auto">
            <ApplicationMark width="190px" />
            <slot name="left"></slot>
        </div>

        <div class="center-area w-full lg:w-auto">
            <div class="dialog-container static lg:fixed inset-0 flex items-center justify-center z-40 lg:pl-32 p-2">
                <div class="bg-white p-6 rounded shadow-lg dialog w-full lg:w-96">
                    <slot name="center"></slot>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import ApplicationMark from "../Jetstream/ApplicationMark";
import JetButton from "../Jetstream/Button";

export default {
    name: 'registerPage',
    components: {
        ApplicationMark, JetButton,
    },
    data: () => ({
        form: {
            account_name: '',
            csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
        },
        loading: false,
        errors: {},
        error_message: "",
        showPhoneNumberValidationError: false,
    }),
    computed: {
    },
    methods: {
        submitForm() {

            this.loading = true;
            this.errors = {};
            this.error_message = "";
            axios.post(route('newOnboarding'), this.form)
                .then(response => {
                    window.location.href = route('dashboard');
                })
                .catch(error => {
                    this.loading = false;
                    if (error.response.status === 419) {
                        this.error_message = "Form is expired";
                    } else {
                        this.errors = error.response.data.errors;
                        if (Array.isArray(error.response.data.message)) {
                            this.error_message = error.response.data.message[0];
                        } else {
                            this.error_message = error.response.data.message;
                        }
                    }
                });
        },
        phoneNumberUpdate(val) {
        },

    }
}
</script>


<style scoped>
.left-guide {
    background-color: white;
    border: 0;
}

.registration-layout {
    border: 0;
    background-size: cover;
    background-position: left;
    min-height: 100vh;
}

.dialog {
    width: 470px;
}

@media all and (min-width: 1024px) {
  .left-guide {
    width: 430px;
  }

  .registration-layout {
    background-image: url('/images/background_blur.jpg');
  }

  .dialog-container {
      padding-left: 430px;
  }
}
</style>
